export default __webpack_public_path__ + "static/media/about.9bc96f31.gif";